import {useParams} from "react-router-dom";
import {Container} from "react-bootstrap";

import {RenderMarkdownGitHub} from "./utils/utilsForMarkdown";

export function RoutesGit() {
    const {base, "*": path} = useParams()
    // const resourcePath = location.pathname.replace(/^\/git/, '') || "README.md"
    // const resourcePath = `${base}/${path || "README.md"}`;

    let resourcePath
    if (!base) {
        resourcePath = path || "README.md"; // root README.md
    } else {
        resourcePath = `${base}/${path || "README.md"}`; // folder README.md
    }

    // Build the GitHub raw URL
    const githubUrl = `https://raw.githubusercontent.com/altrabits/AB_Documents/main/${resourcePath}`

    return <Container fluid="lg">
        {/*<RenderMarkdownGitHub routerPath="/git" github={githubUrl}/>*/}
        <
            RenderMarkdownGitHub routerPath={`/git/${base}`} github={githubUrl}/>
    </Container>
}